import { createTheme } from '@mui/material/styles';
import { typography } from './typography';
import { breakpoints } from './breakpoints';
import { components } from './components';

const darkTheme = createTheme({
  typography,
  components,
  breakpoints,
  palette: {
    background: {
      default: '#121212',
      secondary: '#181818',
    },
    primary: {
      main: '#121212',
    },
    secondary: {
      main: '#ffffff',
    },
    tertiary: {
      main: '#f000ff',
    },
    quaternary: {
      main: '#4deeea',
    },
    default: {
      main: '#ffffff',
    },
    error: {
      main: '#d32f2f',
    },
    colors: {
      dark: '#121212',
      light: '#ffffff',
    },
  },
});

export default darkTheme;
